import React from 'react';
import SpotlightHeader from '../../Common/Header';
import BottomBar from '../../../components/BottomBar';
import './EmployeeHighlight.scss';
const CELEBRATE_IMAGE = 'https://spotlightscdn.upshow.tv/Trophy_v2.png';
const EmployeeHighlight = props => {
  var _metadata$boh_employe, _metadata$boh_employe2;
  const {
    metadata,
    bohStyle,
    text
  } = props;
  const {
    accent_color,
    text_accent_color,
    containerStyle
  } = bohStyle;
  const image = (_metadata$boh_employe = metadata.boh_employee_highlight_info) === null || _metadata$boh_employe === void 0 ? void 0 : _metadata$boh_employe.image;
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  return /*#__PURE__*/React.createElement("div", {
    className: "employee-highlight-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata
  }), /*#__PURE__*/React.createElement("div", {
    className: "employee-highlight-info-container"
  }, image ? /*#__PURE__*/React.createElement("div", {
    className: "employee-highlight-picture-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: "employee-highlight-picture",
    src: image,
    alt: "profile"
  })) : /*#__PURE__*/React.createElement("img", {
    className: "employee-highlight-celebrate",
    src: CELEBRATE_IMAGE,
    alt: "celebrate"
  }), /*#__PURE__*/React.createElement("div", {
    className: "employee-highlight-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "employee-highlight-info-title"
  }, (_metadata$boh_employe2 = metadata.boh_employee_highlight_info) === null || _metadata$boh_employe2 === void 0 ? void 0 : _metadata$boh_employe2.title))), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default EmployeeHighlight;